var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"document-list-item-uri",class:{ '-toc': _vm.variant === 'toc', '-small': _vm.variant === 'small' }},[_c('v-icon',[_vm._v("mdi-web")]),_vm._v("\n  "+_vm._s(_vm.pdfUri.split('//').slice(1).join('/'))+"\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }